import type { EntityKindHandler, AddPickerEntry } from './EntityKindHandler';
import { TaskHandler } from './task/TaskHandler';
import { TextBlockHandler } from './textblock/TextBlockHandler';
import { TextLabelHandler } from './textlabel/TextLabelHandler';
import { GroupHandler } from './group/GroupHandler';
import { WaypointHandler } from './waypoint/WaypointHandler';
import { ConnectorHandler } from './connector/ConnectorHandler';
import { SpriteHandler } from './sprite/SpriteHandler';
import { ImageHandler } from './image/ImageHandler';
import { BlockNodeHandler } from './blocknode/BlockNodeHandler';
import { ShapeHandler } from './shape/ShapeHandler';
import { AdrTriggerHandler } from './adrTrigger/AdrTriggerHandler';

// ============================================
// Entity Kind Registry
// ============================================

export const entityKindRegistry = new Map<string, EntityKindHandler>();

entityKindRegistry.set('task', new TaskHandler());
entityKindRegistry.set('textblock', new TextBlockHandler());
entityKindRegistry.set('textlabel', new TextLabelHandler());
entityKindRegistry.set('group', new GroupHandler());
entityKindRegistry.set('waypoint', new WaypointHandler());
entityKindRegistry.set('connector', new ConnectorHandler());
entityKindRegistry.set('sprite', new SpriteHandler());
entityKindRegistry.set('image', new ImageHandler());
entityKindRegistry.set('blocknode', new BlockNodeHandler());
entityKindRegistry.set('shape', new ShapeHandler());
entityKindRegistry.set('adr-trigger', new AdrTriggerHandler());

export function getHandler(kind: string): EntityKindHandler {
  const handler = entityKindRegistry.get(kind);
  if (!handler) {
    throw new Error(`No handler registered for entity kind: ${kind}`);
  }
  return handler;
}

/** Returns all entity kinds that should appear in the add picker, sorted by priority. */
export function getAddPickerEntries(): Array<{ kind: string; entry: AddPickerEntry }> {
  const entries: Array<{ kind: string; entry: AddPickerEntry }> = [];
  for (const [kind, handler] of entityKindRegistry) {
    const entry = handler.getAddPickerEntry();
    if (entry) entries.push({ kind, entry });
  }
  return entries.sort((a, b) => a.entry.priority - b.entry.priority);
}
